import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const { INPUT, DATE,DATE_DISABLE_NO_DAY, COMBO_BOX, AUTO_COMPLETE, CURRENCY, NUMBER ,DATE_DAY_INPUT} = FIELD_TYPE;
const dataFields: DataFormField[] = [

  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: true,
    rules: [{required: true, message: "Chưa nhập lấy họ tên"}],
  },

  {
    type: INPUT,
    label: "Số giấy phép",
    name: "soGiayPhep",
    disable: false,
    rules: [{required: true, message: "Chưa nhập số giấy phép"}],
  },
  {
    type: DATE_DAY_INPUT,
    label: "Ngày cấp",
    name: "ngayCap",
    disableDate:false,
    disable: false,
    rules: [{required: true, message: "Chưa nhập ngày cấp"}],
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type:COMBO_BOX ,
    label: "Phạm vi hoạt động",
    name: "phamViHoatDong",
    disable: false,
    // options: [
    //   { value: "Khám bệnh", label: "Khám bệnh" },
    //   { value: "Kỹ thuật viên chụp x-quang", label: "Kỹ thuật viên chụp x-quang" },
    // ],
  },
  {
    type: AUTO_COMPLETE,
    label: "Bộ y tế",
    name: "soYTe",
    disable: false,
    rules: [{required: true, message: "Chưa nhập sở y tế"}],
    options: [
      { value: "Bộ y tế", label: "Bộ y tế" },
      { value: "Sở y tế", label: "Sở y tế" },
    ],
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày có hiệu lực",
    name: "ngayCoHieuLuc",
    disable: false,
    rules: [{required: true, message: "Chưa nhập ngày có hiệu lực"}],
    // optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    disableDate:false,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày hết hiệu lực",
    name: "ngayHetHieuLuc",
    disableDate:false,
    disable: false,
    // rules: [{required: true, message: "Chưa nhập ngày hết hiệu lực"}],
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: INPUT,
    label: "Ghi chú",
    css: {
      xl: 16,
      lg: 12,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
    name: "ghiChu",
    disable: false,
  },
];
export {dataFields};
